import type { VolatilityEntry } from '@/types/prices/volatility'

export type VolatilityViewEntry = VolatilityEntry & {
  direction: 'up' | 'down' | 'flat'
}

export function mapVolatilityEntries(entries: VolatilityEntry[]): VolatilityViewEntry[] {
  return entries.map((entry) => {
    let direction: VolatilityViewEntry['direction'] = 'flat'
    if (entry.priceDelta > 0) direction = 'up'
    if (entry.priceDelta < 0) direction = 'down'

    return {
      ...entry,
      direction,
    }
  })
}
